function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolTip({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7.06699 0.749999C7.25944 0.416667 7.74056 0.416666 7.93301 0.75L13.5622 10.5C13.7546 10.8333 13.5141 11.25 13.1292 11.25H1.87083C1.48593 11.25 1.24537 10.8333 1.43782 10.5L7.06699 0.749999Z",
    fill: "white",
    stroke: "#D9E5F8",
    style: {
      fill: "white",
      fillOpacity: 1,
      stroke: "#D9E5F8",
      stroke: "color(display-p3 0.8510 0.8980 0.9725)",
      strokeOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolTip);
export default __webpack_public_path__ + "static/media/toolTip.f1d42d37611d03754e2de6433309ff23.svg";
export { ForwardRef as ReactComponent };